// extracted by mini-css-extract-plugin
export default {"main":"contacts_main__tGoBM"};